var map = {
	"./24-7.jpg": 433,
	"./avatar.jpg": 389,
	"./avatarDoctor.jpg": 803,
	"./doctor.jpg": 542,
	"./doctorProfile.jpg": 654,
	"./expert.jpg": 914,
	"./findDoctor.jpg": 950,
	"./hero-img.jpg": 568,
	"./hero.jpg": 611,
	"./homepage-img1.jpg": 921,
	"./login-phone.jpg": 841,
	"./login.jpg": 0,
	"./pres.jpg": 229,
	"./schedule.jpg": 717,
	"./solutions.jpg": 134,
	"./t1.jpg": 766,
	"./t2.jpg": 216,
	"./t3.jpg": 714,
	"./virtual-chat.jpg": 145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;